import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import academicService from './academicService'
import axios from 'axios'
const api = '/api/'

export const ListTerm = createAsyncThunk('term-list', async (params: {}, thunkAPI) => {
  try {
    return await academicService.termList({ params })
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const createTerm = createAsyncThunk('term-create', async (data: {}, thunkAPI) => {
  try {
    return await academicService.termCreate({ data })
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const editTerm = createAsyncThunk('term-edit', async (id: string, thunkAPI) => {
  try {
    return await academicService.termEdit(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const deleteTerm = createAsyncThunk('term-delete', async (id: string, thunkAPI) => {
  try {
    return await academicService.termDelete(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const viewTerm = createAsyncThunk('term-view', async (id: string, thunkAPI) => {
  try {
    return await academicService.termView(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetFaculties = createAsyncThunk('get-facs', async (id: string, thunkAPI) => {
  try {
    return await academicService.getFaculties(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetDeps = createAsyncThunk('get-deps', async (id: string, thunkAPI) => {
  try {
    return await academicService.getDeps(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ListTermClass = createAsyncThunk('term-class-list', async (id: string, thunkAPI) => {
  try {
    return await academicService.termClassList(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const createTermClass = createAsyncThunk('term-class-create', async (data: {}, thunkAPI) => {
  try {
    return await academicService.termClassCreate({ data })
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const editTermClass = createAsyncThunk('term-class-edit', async (id: string, thunkAPI) => {
  try {
    return await academicService.termClassEdit(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const deleteTermClass = createAsyncThunk(
  'term-class-delete',
  async (id: string, thunkAPI) => {
    try {
      return await academicService.termClassDelete(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const createTermClassSemester = createAsyncThunk('term-class-semester-create', async (data: {}, thunkAPI) => {
  try {
    return await academicService.termClassSemesterCreate({ data })
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ListTermClassSemester = createAsyncThunk('term-class-semester-list', async (id: string, thunkAPI) => {
  try {
    return await academicService.termClassSemesterList(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const editTermClassSemester = createAsyncThunk('term-class-semester-edit', async (id: string, thunkAPI) => {
  try {
    return await academicService.termClassSemesterEdit(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ListTermClassSchedule = createAsyncThunk('term-class-schedule-list', async (params: {}, thunkAPI) => {
  try {
    return await academicService.termClassScheduleList({ params })
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const TermClassSubjectCreate = createAsyncThunk('term-class-subject-create', async (data: {}, thunkAPI) => {
  try {
    return await academicService.termClassSubjectCreate({ data })
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const TermSemesterScheduleDropDownData = createAsyncThunk('term-semester-schedule-data', async (params: {}, thunkAPI) => {
  try {
    return await academicService.termSemesterScheduleDropDownData({ params })
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const TermSemesterScheduleCreate = createAsyncThunk('term-semester-schedule-create', async (data: {}, thunkAPI) => {
  try {
    return await academicService.termSemesterScheduleCreate({ data })
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const editTermSemesterSchedule = createAsyncThunk('term-semester-schedule-edit', async (id: string, thunkAPI) => {
  try {
    return await academicService.termSemesterScheduleEdit(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const TermSemesterScheduleUpdate = createAsyncThunk('term-semester-schedule-update', async (data: {}, thunkAPI) => {
  try {
    return await academicService.termSemesterScheduleUpdate({ data })
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const deleteTermSemesterSchedule = createAsyncThunk('term-semester-delete', async (id: string, thunkAPI) => {
  try {
    return await academicService.termSemesterScheduleDelete(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
}
)

export const PrintTermSemesterSchedule = createAsyncThunk('print-term-semester-schedule', async (params: {}, thunkAPI) => {
  try {
    const response = await axios.get(`${api}term/semester-schedule-print`, params)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
}
)

type AcademicState = {
  errors: any
}

const initialState: AcademicState = {
  errors: '',
}

export const academicSlice = createSlice({
  name: 'academic',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(createTerm.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
  },
})

export const { reset } = academicSlice.actions
export default academicSlice.reducer
